/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pumps_Permutation_Text_2Inputs */

const fr_pumps_permutation_text_2 = /** @type {((inputs: Pumps_Permutation_Text_2Inputs) => LocalizedString) & { parts: (inputs: Pumps_Permutation_Text_2Inputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Pumps_Permutation_Text_2Inputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Lorsque la permutation des chaudières est en auto, la permutation des pompes doubles s’effectue au même moment (Voir )`)
		}),
		{
			parts: /** @type {(inputs: Pumps_Permutation_Text_2Inputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Lorsque la permutation des chaudières est en auto, la permutation des pompes doubles s’effectue au même moment (Voir " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: ")" }])
			})
		}
	)
);

const en_pumps_permutation_text_2 = /** @type {((inputs: Pumps_Permutation_Text_2Inputs) => LocalizedString) & { parts: (inputs: Pumps_Permutation_Text_2Inputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Pumps_Permutation_Text_2Inputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`When boiler changeover is set to auto, double pumps are changed over at the same time (see ).`)
		}),
		{
			parts: /** @type {(inputs: Pumps_Permutation_Text_2Inputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "When boiler changeover is set to auto, double pumps are changed over at the same time (see " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: ")." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "When boiler changeover is set to auto, double pumps are changed over at the same time (see )." |
*
* @param {Pumps_Permutation_Text_2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const pumps_permutation_text_2 = /** @type {((inputs?: Pumps_Permutation_Text_2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & { parts: (inputs?: Pumps_Permutation_Text_2Inputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Pumps_Permutation_Text_2Inputs, { locale?: "fr" | "en" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Pumps_Permutation_Text_2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "en") return en_pumps_permutation_text_2(inputs)
			return fr_pumps_permutation_text_2(inputs)
		}),
		{
			parts: /** @type {(inputs?: Pumps_Permutation_Text_2Inputs, options?: { locale?: "fr" | "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "en") return /** @type {{ parts?: (inputs: Pumps_Permutation_Text_2Inputs) => import('../runtime.js').MessagePart[] }} */ (en_pumps_permutation_text_2).parts?.(inputs) ?? [{ type: "text", value: en_pumps_permutation_text_2(inputs) }]
				return /** @type {{ parts?: (inputs: Pumps_Permutation_Text_2Inputs) => import('../runtime.js').MessagePart[] }} */ (fr_pumps_permutation_text_2).parts?.(inputs) ?? [{ type: "text", value: fr_pumps_permutation_text_2(inputs) }]
			})
		}
	)
);